export default function StoreCloud({ stores }) {
  if (stores.length === 0) return null;

  return (
    <div
      className="exhibition-card"
      style={{ width: "100%", marginBottom: "10px" }}
    >
      <h2
        className="exhibition-title"
        style={{ fontSize: 13, marginBottom: "20px" }}
      >
        برای مشاهده کانال هر غرفه در وقف نما، روی غرفه مورد نظر کلیک کنید.
      </h2>
      <div
        style={{
          display: "flex",
          gap: "5px",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {stores.map((f, idx) => {
          return (
            <a
              key={idx}
              className="exhibition-btn storeCloud"
              style={{
                color: "#fffafa",
                background: "var(--site-theme-dark)",
                width: "fit-content",
              }}
              href={f.vaghfnama_channel_address}
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="exhibition-stack"
                style={{ alignItems: "center" }}
              >
                <div
                  className="exhibition-title"
                  style={{ fontSize: 12, margin: 0 }}
                >
                  {f.store_name}
                </div>
              </div>
            </a>
          );
        })}
        {[
          {
            vaghfnama_channel_address: "https://vaghfnama.ir/single-channel/84",
            store_name: "بیمارستان موقوفه بازرگان",
          },
          {
            vaghfnama_channel_address: "https://vaghfnama.ir/single-channel/91",
            store_name: "بیمارستان موقوفه گودرز",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/300",
            store_name: "مرکز امور خیریه",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/299",
            store_name: "دهکده موقوفه گردشگری محب سلامت",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/297",
            store_name: "بیمارستان موقوفه محب مهر",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/298",
            store_name: "سفره موقوفه محب سلامت",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/301",
            store_name: "درمانگاه موقوفه المهدی خانی آباد نو",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/302",
            store_name: "درمانگاه موقوفه المهدی پاسداران",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/303",
            store_name: "درمانگاه موقوفه والفجر کاشانک",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/139",
            store_name: "شرکت صندوق پژوهش و فناوری غیر دولتی ماندگار",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/294",
            store_name: "ایلیا بنیان دانش ماندگار",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/295",
            store_name: "مبدل سرام ماندگار",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/296",
            store_name: "شرکت توسعه فناوری های نافع ماندگار",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/305",
            store_name: "شرکت فلزات آلیاژی ماندگار",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/304",
            store_name: "شرکت دانش‌بنیان پارس اهم",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/141",
            store_name: "شرکت پترو فن آوری پایا",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/175",
            store_name: "صدای بهار",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/306",
            store_name: "سپهر فناوری",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/177",
            store_name: "صندوق قرض الحسنه وقف ماندگار",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/307",
            store_name: "امنا",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/308",
            store_name:
              "مرکز تربیتی، آموزشی، شبانه روزی ویژه ایتام موقوفه زنده یاد لطف الله محرر",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/309",
            store_name:
              "مجتمع پرورشی، آموزشی، چندمنظوره شبانه روزی ایتام موقوفه زنده یاد حاج خلیل زالی",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/289",
            store_name: "مرکز تربیتی آموزشی ایتام موقوفه زنده یاد مصلایی",
          },
          {
            vaghfnama_channel_address:
              "https://vaghfnama.ir/single-channel/310",
            store_name: "مرکز فناوری اطلاعات و امنیت فضای مجازی",
          },
        ].map((f, idx) => {
          return (
            <a
              key={idx}
              className="exhibition-btn storeCloud"
              style={{
                color: "#fffafa",
                background: "var(--site-theme-dark)",
                width: "fit-content",
              }}
              href={f.vaghfnama_channel_address}
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="exhibition-stack"
                style={{ alignItems: "center" }}
              >
                <div
                  className="exhibition-title"
                  style={{ fontSize: 12, margin: 0 }}
                >
                  {f.store_name}
                </div>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
}
